var map = {
	"./icon_anotacao_branco.png": 74260,
	"./icon_aplicacao_afericao_branco.png": 15984,
	"./icon_aplicacao_amarelo.png": 87669,
	"./icon_aplicacao_branco.png": 17409,
	"./icon_aplicacao_verde.png": 36668,
	"./icon_aplicacao_vermelho.png": 53476,
	"./icon_aspecto_geral_branco.png": 64082,
	"./icon_climatica_amarelo.png": 58050,
	"./icon_climatica_verde.png": 10513,
	"./icon_climatica_vermelho.png": 11183,
	"./icon_colheita_afericao_branco.png": 56252,
	"./icon_doenca_amarelo.png": 30517,
	"./icon_doenca_azul.png": 30595,
	"./icon_doenca_branco.png": 75733,
	"./icon_doenca_roxo.png": 82183,
	"./icon_doenca_verde.png": 70146,
	"./icon_doenca_vermelho.png": 92704,
	"./icon_generico_branco.png": 58469,
	"./icon_inimigo_natural_amarelo.png": 36468,
	"./icon_inimigo_natural_branco.png": 87170,
	"./icon_inimigo_natural_verde.png": 13198,
	"./icon_inimigo_natural_vermelho.png": 17869,
	"./icon_inseto_amarelo.png": 54296,
	"./icon_inseto_azul.png": 88241,
	"./icon_inseto_branco.png": 21916,
	"./icon_inseto_roxo.png": 96634,
	"./icon_inseto_verde.png": 83425,
	"./icon_inseto_vermelho.png": 86682,
	"./icon_invasora_amarelo.png": 76586,
	"./icon_invasora_azul.png": 95311,
	"./icon_invasora_branco.png": 1376,
	"./icon_invasora_roxo.png": 50764,
	"./icon_invasora_verde.png": 21081,
	"./icon_invasora_vermelho.png": 92691,
	"./icon_manutencao_melhoria_amarelo.png": 21663,
	"./icon_manutencao_melhoria_branco.png": 79056,
	"./icon_manutencao_melhoria_verde.png": 56168,
	"./icon_manutencao_melhoria_vermelho.png": 13673,
	"./icon_massa_seca_pastagem_amarelo.png": 21755,
	"./icon_nematoide_amarelo.png": 98831,
	"./icon_nematoide_azul.png": 78347,
	"./icon_nematoide_branco.png": 1909,
	"./icon_nematoide_roxo.png": 675,
	"./icon_nematoide_verde.png": 94144,
	"./icon_nematoide_vermelho.png": 88434,
	"./icon_produtividade_amarelo.png": 67067,
	"./icon_produtividade_branco.png": 26834,
	"./icon_produtividade_verde.png": 98086,
	"./icon_produtividade_vermelho.png": 27749,
	"./icon_recomendacao_amarelo.png": 63781,
	"./icon_recomendacao_branco.png": 51845,
	"./icon_recomendacao_verde.png": 64812,
	"./icon_recomendacao_vermelho.png": 54800,
	"./icon_semeadura_afericao_branco.png": 32477,
	"./icon_solo_amarelo.png": 38394,
	"./icon_solo_branco.png": 27681,
	"./icon_solo_verde.png": 681,
	"./icon_solo_vermelho.png": 10534,
	"./icon_stand_amarelo.png": 6573,
	"./icon_stand_branco.png": 58684,
	"./icon_stand_verde.png": 73528,
	"./icon_stand_vermelho.png": 26566,
	"./icon_tarefa_amarelo.png": 51496,
	"./icon_tarefa_concluida.png": 36088,
	"./icon_visita_amarelo.png": 30281,
	"./icon_visita_verde.png": 86248,
	"./icon_visita_vermelho.png": 80149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23128;